import React, { Component } from 'react';
import { 
  shape, 
  func, 
  string, 
  number, 
  bool, 
  objectOf, 
  arrayOf 
} from 'prop-types';
import styles from './styles.scss';
import cx from 'classnames';
import { isNumber } from 'lodash';

export default class DeviceTableRow extends Component {
  static propTypes = {
    data: arrayOf(shape({
      deviceId: string,
      deviceType: string,
      totalVisits: number,
      adVisits: number,
      ads: number, 
      visitOfAds: number,
    })),
    onCellClick: func,
    isCustomReport: bool,
    summaryData: shape({
      deviceId: string,
      deviceType: string,
      totalVisits: number,
      adVisits: number,
      ads: number, 
      visitOfAds: number,
    }),
    tableColumns: objectOf(shape({
      title: string,
      key: string
    }))
  }

  static defaultProps = {
    data: {},
    summaryData: {}
  }

  render() {
    const { 
      data,
      onCellClick,
      isCustomReport,
      summaryData,
      tableColumns
    } = this.props;
    const {
      adVisits: totalAdVisits,
    } = summaryData;
    const { 
      deviceType, 
      visitOfAds, 
      adVisits, 
      ads, 
      totalVisits,
    } = data;
    const adVisitsRate = totalAdVisits && parseFloat((adVisits / totalAdVisits) * 100).toFixed(1) || 0;
    const formattedAdVisit = `${parseFloat(adVisits.toFixed(1)).toLocaleString()} (${adVisitsRate}%)`;
    const tableCellClasses = isCustomReport ? cx(styles.tableCell, styles.customTableCell) : styles.tableCell;
    const formattedVisitOfAds = isNumber(visitOfAds) ? parseFloat(visitOfAds.toFixed(2)).toLocaleString() : 'N/A';
    const formattedData = {
      deviceType,
      adVisits: formattedAdVisit,
      ads: ads.toLocaleString(),
      visitOfAds: formattedVisitOfAds,
      totalVisits,
    };
    return (
      <div className={styles.tableRow} data-test="deviceTableRow">
        {
          Object.keys(tableColumns).map(key => (
            <div
              key={key}
              className={tableCellClasses}
              onClick={onCellClick({data, key})}
              data-test={"deviceCategoryTable" + key.charAt(0).toUpperCase() + key.slice(1)}
            >
              {formattedData[key]}
            </div>
          ))
        }
      </div>
    )
  }
}
